import { Dictionary, keyBy, uniqueId } from 'lodash';
import { DateType } from 'api/models';
import {
  ProjectFinancialsFieldNames,
  ProjectFinancialsTableApiData,
  ProjectFinancialsTableRowApiData,
  ProjectFinancialsTableRowData,
} from 'api/project';
import { RateCardLite } from 'api/rate-cards';
import { Field } from 'api/tasks';
import { sortByDates } from './sort-by-dates';

export const strigifyArray = (array: string, separator = '_'): string =>
  array.split(' ').join(separator);

const flattenFinancialBreakdownDetails = (
  {
    childrenBreakdown,
    breakdownDetails,
    ...rest
  }: ProjectFinancialsTableRowApiData,
  parents: string[] = [],
): ProjectFinancialsTableRowData[] => {
  const result: ProjectFinancialsTableRowData[] = [];
  const isAlias = parents.includes(rest.sourceName);
  const hierarchy = parents.concat([
    uniqueId(`${strigifyArray(rest.sourceName)}_`),
  ]);

  result.push({
    ...rest,
    hierarchy,
    breakdownDetails: keyBy(breakdownDetails, 'startDate'),
    isAlias,
    childCount: childrenBreakdown?.length,
  });

  if (childrenBreakdown == null || childrenBreakdown.length === 0) {
    return result;
  }

  return result.concat(
    ...childrenBreakdown.map((data) =>
      flattenFinancialBreakdownDetails(data, hierarchy),
    ),
  );
};

export const getFinancialsTableRowData = (
  financialsData: ProjectFinancialsTableApiData,
): ProjectFinancialsTableRowData[] =>
  (financialsData.breakdown ?? []).reduce(
    (result, rowItem) => [
      ...result,
      ...flattenFinancialBreakdownDetails(rowItem),
    ],
    [] as ProjectFinancialsTableRowData[],
  );

export const getFinancialsFieldIdFromLookupByName = (
  fieldName: ProjectFinancialsFieldNames,
  fieldsLookup?: Dictionary<Field>,
): number | undefined => fieldsLookup?.[fieldName]?.fieldId;

export const rateCardsSorter = (rateCards: RateCardLite[]): RateCardLite[] =>
  rateCards
    .sort(({ updatedAt: dateA }, { updatedAt: dateB }) =>
      sortByDates(dateB as DateType, dateA as DateType, 'milliseconds'),
    )
    .sort(({ enabled: enabledA }, { enabled: enabledB }) => {
      if (enabledA === true && enabledB === false) {
        return -1;
      }

      if (enabledA === false && enabledB === true) {
        return 1;
      }

      return 0;
    });
